import React from 'react'
import PropTypes from 'prop-types'
import { cn } from '@codecraftkit/theme'
import { ProfileImageBaseAvatar } from './../ProfileImageBaseAvatar'
import { container, title } from './styles'

/**
 * The image plus its caption.
 *
 * `children` is a render function: a consumer that wants its own layout gets the avatar back as a
 * component and places it itself.
 */
export const ProfileImageBase = ({
  isRounded, noShadow, item, urlField, nameField, onOpen, isOpen, onClose, imageTitle, image,
  isDisabled, noBorder, noTitle, children, isLoading, className
}) => {
  const AvatarImage = props => (
    <ProfileImageBaseAvatar
      isRounded={isRounded}
      image={image}
      urlField={urlField}
      item={item}
      nameField={nameField}
      noShadow={noShadow}
      isDisabled={isDisabled}
      onOpen={onOpen}
      isLoading={isLoading}
      noBorder={noBorder}
      {...props}
    />
  )

  if (children) return children({ AvatarImage, item, onOpen, isOpen, onClose })

  return (
    <div className={cn(container(noBorder), className)}>
      <AvatarImage />
      {/*
        * `<h2>` and not Chakra's `<Heading>`, which defaults to `h2` as well. The level matters:
        * a caption under an avatar is not the page's title, so a consumer nesting this inside a
        * section gets a heading at the level they expect rather than one Chakra chose.
        */}
      {!noTitle && <h2 className={title}>{item?.[nameField] || imageTitle || 'New'}</h2>}
    </div>
  )
}

ProfileImageBase.propTypes = {
  item: PropTypes.object,
  nameField: PropTypes.string,
  urlField: PropTypes.string,
  image: PropTypes.string,
  imageTitle: PropTypes.node,
  isRounded: PropTypes.bool,
  noShadow: PropTypes.bool,
  noBorder: PropTypes.bool,
  noTitle: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  onOpen: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  /** Render function: `({ AvatarImage, item, onOpen, isOpen, onClose }) => node`. */
  children: PropTypes.func,
  className: PropTypes.string
}
